export default "__VITE_ASSET__Cet_ueGG__"